import { Injectable } from '@angular/core';
import { DataService } from '../data.service';
import { PreBillingSearchItem } from '../../model/billing/pre-billing-search-item';
import { BillingInvoiceItemEditInfo } from '../../model/billing/billing-invoice-item-edit-info';
import { ReportViewer } from '../../model/report-viewer';

@Injectable({
  providedIn: 'root'
})
export class PreBillingService {

  constructor( private dataService: DataService ) { }

  private readonly getPendientPreBillingSearchItemsEndPoint: string =
      '/preBilling/getPendientPreBillingSearchItems/';

  private readonly getMedicalAppointmentProcedureIdsEndPoint: string =
      '/preBilling/getMedicalAppointmentProcedureIds/';

  private readonly getPreBillingInvoiceItemsEndPoint: string =
      '/preBilling/getPreBillingInvoiceItems/';

  private readonly getPreBillingReportEndPoint: string =
      '/preBilling/getPreBillingReport/';

  private readonly asociateBillingManualEndPoint: string =
      '/preBilling/asociateBillingManual/';

  async asociateBillingManual( preBillingId: number, billingManualId: number ): Promise<boolean> {
    const params = { preBillingId, billingManualId };
    return await this.dataService
                      .post<boolean>(this.asociateBillingManualEndPoint, params)
                      .toPromise();
  }

  async getPreBillingReport( preBillingId: number, centerId: number ): Promise<ReportViewer> {
    const params = { preBillingId, centerId };
    return await this.dataService
                      .get<ReportViewer>(this.getPreBillingReportEndPoint, params)
                      .toPromise();
  }

  async getPreBillingInvoiceItems( preBillingId: number ): Promise<BillingInvoiceItemEditInfo[]> {
    const params = { preBillingId: preBillingId };
    return await this.dataService
                     .get<BillingInvoiceItemEditInfo[]>(this.getPreBillingInvoiceItemsEndPoint, params)
                     .toPromise();
  }

  async getMedicalAppointmentProcedureIds( preBillingId: number ): Promise<number[]> {
    const params = { preBillingId: preBillingId };
    return await this.dataService
                     .get<number[]>(this.getMedicalAppointmentProcedureIdsEndPoint, params)
                     .toPromise();
  }


  async getBillingClosePreBillings( clientCode: string, id?: number, clientId?: number,
    from?: Date, to?: Date ): Promise<PreBillingSearchItem[]> {

    let toUtc = '';
    let fromUtc = '';

    if ( from ) {
      fromUtc = new Date(from.getFullYear(), from.getMonth(), from.getDate()).toDateString();
    }

    if ( to ) {
      toUtc = new Date(to.getFullYear(), to.getMonth(), to.getDate()).toDateString();
    }

    const params = {
      clientCode: clientCode,
      id: id,
      clientId: clientId,
      from: fromUtc,
      to: toUtc
    };

    return await this.dataService.get<PreBillingSearchItem[]>(this.getPendientPreBillingSearchItemsEndPoint, params)
      .toPromise();
 }
}
